import { ReactEditor } from 'slate-react';

// After a programmatic paste insert, slate-react does NOT run its usual
// scroll-selection-into-view (we preventDefault the paste at capture phase and
// insert the fragment ourselves). The caret therefore lands wherever the insert
// left it — frequently below the fold inside the editor's `contentScroll`
// container — with no viewport movement, so the paste looks like it did nothing.
//
// Reveal the caret only if it landed off-screen. `block:'nearest'` scrolls the
// nearest scrollable ancestor (the editor's scroll container OR the page) just
// enough to bring the caret into view — and does nothing when it's already
// visible, so a paste at the cursor doesn't yank the viewport. Deferred to a RAF
// so the inserted DOM has laid out before we measure, with a single one-RAF retry
// for the case where the inserted nodes haven't been committed on the first frame.
export function scrollCaretIntoView(editor: any): void {
    if (!editor) return;
    try {
        editor?.tf?.focus?.();
    } catch {
        /* editor may not be mounted */
    }
    const attempt = (retry: boolean): void => {
        try {
            const selection = editor?.selection;
            if (!selection) return;
            const domRange = ReactEditor.toDOMRange(editor as any, selection);
            const node = domRange.endContainer instanceof HTMLElement ? domRange.endContainer : domRange.endContainer.parentElement;
            node?.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
        } catch {
            // Selection may not be laid out yet on the first frame — retry once.
            if (retry) requestAnimationFrame(() => attempt(false));
        }
    };
    requestAnimationFrame(() => attempt(true));
}
